// src/config/data.js
export const ALL_CLUE_CARDS = [
  { id: "clue1", name: "ถ่านอัลคาไลน์", url: "/images/clues/clue_alka.png" },
  { id: "clue2", name: "ตุ๊กตาหมี", url: "/images/clues/clue_bear.png" },
  { id: "clue3", name: "สายฉีดชำระ", url: "/images/clues/clue_bidet.png" },
  { id: "clue4", name: "นก", url: "/images/clues/clue_bird.png" },
  { id: "clue5", name: "???", url: "/images/clues/clue_blank.png" },
  { id: "clue6", name: "หนังสือ", url: "/images/clues/clue_book.png" },
  { id: "clue7", name: "กล่อง", url: "/images/clues/clue_box.png" },
  { id: "clue8", name: "แก้วที่แตก", url: "/images/clues/clue_breaking.png" },
  { id: "clue9", name: "แฮมเบอร์เกอร์", url: "/images/clues/clue_burger.png" },
  { id: "clue10", name: "ผีเสื้อ", url: "/images/clues/clue_butterfly.png" },
  { id: "clue11", name: "กระดุม", url: "/images/clues/clue_button.png" },
  { id: "clue12", name: "สายเคเบิล", url: "/images/clues/clue_cable.png" },
  { id: "clue13", name: "เครื่องคิดเลข", url: "/images/clues/clue_cal.png" },
  { id: "clue14", name: "กล้องถ่ายรูป", url: "/images/clues/clue_camera.png" },
  { id: "clue15", name: "เทียน", url: "/images/clues/clue_candle.png" },
  { id: "clue16", name: "ไพ่", url: "/images/clues/clue_card.png" },
  { id: "clue17", name: "ซีดี", url: "/images/clues/clue_cd.png" },
  { id: "clue18", name: "โซ่", url: "/images/clues/clue_chain.png" },
  { id: "clue19", name: "ไปป์ยาสูบ", url: "/images/clues/clue_ciggar.png" },
  { id: "clue20", name: "ก้อนเมฆ", url: "/images/clues/clue_cloud.png" },
  { id: "clue21", name: "เหรียญ", url: "/images/clues/clue_coin.png" },
  { id: "clue22", name: "เข็มทิศ", url: "/images/clues/clue_compass.png" },
  { id: "clue23", name: "จอยคอนโทรลเลอร์", url: "/images/clues/clue_controller.png" },
  { id: "clue24", name: "คนคู่", url: "/images/clues/clue_couple.png" },
  { id: "clue25", name: "ปู", url: "/images/clues/clue_crab.png" },
  { id: "clue26", name: "มงกุฏพระราชา", url: "/images/clues/clue_crown.png" },
  { id: "clue27", name: "ดอกหญ้า", url: "/images/clues/clue_dandi.png" },
  { id: "clue28", name: "ลูกเต๋า", url: "/images/clues/clue_dice.png" },
  { id: "clue29", name: "สุนัข", url: "/images/clues/clue_dog.png" },
  { id: "clue30", name: "โดนัท", url: "/images/clues/clue_donut.png" },
  { id: "clue31", name: "แฟลชไดรฟ์", url: "/images/clues/clue_flashdrive.png" },
  { id: "clue32", name: "ไฟฉาย", url: "/images/clues/clue_flashlight.png" },
  { id: "clue33", name: "ลูกฟุตบอล", url: "/images/clues/clue_football.png" },
  { id: "clue34", name: "ไฟแช็ก", url: "/images/clues/clue_gaslighter.png" },
  { id: "clue35", name: "แว่นตา", url: "/images/clues/clue_glasses.png" },
  { id: "clue36", name: "ถุงมือ", url: "/images/clues/clue_glove.png" },
  { id: "clue37", name: "กีตาร์", url: "/images/clues/clue_guitar.png" },
  { id: "clue38", name: "ปืน", url: "/images/clues/clue_gun.png" },
  { id: "clue39", name: "หมวก", url: "/images/clues/clue_hat.png" },
  { id: "clue40", name: "หูฟัง", url: "/images/clues/clue_headphone.png" },
  { id: "clue41", name: "บ้าน", url: "/images/clues/clue_house.png" },
  { id: "clue42", name: "ไอศครีม", url: "/images/clues/clue_icecream.png" },
  { id: "clue43", name: "กุญแจ", url: "/images/clues/clue_key.png" },
  { id: "clue44", name: "หมวกอัศวิน", url: "/images/clues/clue_knight.png" },
  { id: "clue45", name: "มีด", url: "/images/clues/clue_knive.png" },
  { id: "clue46", name: "โน๊ตบุ๊ค", url: "/images/clues/clue_laptop.png" },
  { id: "clue47", name: "ลิปสติก", url: "/images/clues/clue_lipstick.png" },
  { id: "clue48", name: ".....", url: "/images/clues/clue_middle.png" },
  { id: "clue49", name: "เงิน", url: "/images/clues/clue_money.png" },
  { id: "clue50", name: "หมูกระทะ", url: "/images/clues/clue_mookrata.png" },
  { id: "clue51", name: "มอเตอร์ไซค์", url: "/images/clues/clue_motor.png" },
  { id: "clue52", name: "พู่กันจานสี", url: "/images/clues/clue_palette.png" },
  { id: "clue53", name: "แบมือ", url: "/images/clues/clue_paper.png" },
  { id: "clue54", name: "โทรศัพท์มือถือ", url: "/images/clues/clue_phone.png" },
  { id: "clue55", name: "กระปุกออมสิน", url: "/images/clues/clue_pig.png" },
  { id: "clue56", name: "เข็มหมุด", url: "/images/clues/clue_pin.png" },
  { id: "clue57", name: "พลาสเตอร์แปะแผล", url: "/images/clues/clue_plaster.png" },
  { id: "clue58", name: "กระดาษโพสอิท", url: "/images/clues/clue_postit.png" },
  { id: "clue59", name: "วิทยุ", url: "/images/clues/clue_radio.png" },
  { id: "clue60", name: "โบว์ผูกผม", url: "/images/clues/clue_ribbon.png" },
  { id: "clue61", name: "กำปั้น", url: "/images/clues/clue_rock.png" },
  { id: "clue62", name: "สองนิ้ว", url: "/images/clues/clue_scissor.png" },
  { id: "clue63", name: "ไขควง", url: "/images/clues/clue_screwdriver.png" },
  { id: "clue64", name: "รองเท้าผ้าใบ", url: "/images/clues/clue_sneaker.png" },
  { id: "clue65", name: "แมงมุม", url: "/images/clues/clue_spider.png" },
  { id: "clue66", name: "ยอดเยี่ยม", url: "/images/clues/clue_thumbs.png" },
  { id: "clue67", name: "สายฟ้า", url: "/images/clues/clue_thunder.png" },
  { id: "clue68", name: "เนคไท", url: "/images/clues/clue_tie.png" },
  { id: "clue69", name: "ไฟจราจร", url: "/images/clues/clue_traffic.png" },
  { id: "clue70", name: "สองมือ", url: "/images/clues/clue_twohands.png" },
  { id: "clue71", name: "ร่ม", url: "/images/clues/clue_umbrella.png" },
  { id: "clue72", name: "เสื้อกล้าม", url: "/images/clues/clue_vest.png" },
  { id: "clue73", name: "นาฬิกาลูกตุ้ม", url: "/images/clues/clue_vintageclock.png" },
  { id: "clue74", name: "นาฬิกาข้อมือ", url: "/images/clues/clue_watch.png" },
  { id: "clue75", name: "แก้วไวน์", url: "/images/clues/clue_wine.png" },
  { id: "clue76", name: "กระเป๋าสะพาย", url: "/images/clues/clue_backpack.png" },
  { id: "clue77", name: "กล้วย", url: "/images/clues/clue_banana.png" },
  { id: "clue78", name: "ค้างคาว", url: "/images/clues/clue_bat.png" },
  { id: "clue79", name: "เก๊กฮวยมีฟอง", url: "/images/clues/clue_beer.png" },
  { id: "clue80", name: "ระฆัง", url: "/images/clues/clue_bell.png" },
  { id: "clue81", name: "บิ๊กฟุต", url: "/images/clues/clue_bigfoot.png" },
  {
    id: "clue82",
    name: "ตุ๊กตาหัวสปริง",
    url: "/images/clues/clue_bobbing_head.png",
  },
  { id: "clue83", name: "รองเท้าบูท", url: "/images/clues/clue_boots.png" },
  { id: "clue84", name: "กระบอกน้ำ", url: "/images/clues/clue_bottle.png" },
  { id: "clue85", name: "ปฏิทิน", url: "/images/clues/clue_calendar.png" },
  { id: "clue86", name: "ม้วนเทป", url: "/images/clues/clue_cassette.png" },
  { id: "clue87", name: "ต้นมะพร้าว", url: "/images/clues/clue_coconut.png" },
  { id: "clue88", name: "เมล็ดกาแฟ", url: "/images/clues/clue_coffee_bean.png" },
  { id: "clue89", name: "บัตรเครดิต", url: "/images/clues/clue_credit_card.png" },
  { id: "clue90", name: "เป้าลูกดอก", url: "/images/clues/clue_dart_board.png" },
  { id: "clue91", name: "แมลงปอ", url: "/images/clues/clue_dragonfly.png" },
  { id: "clue92", name: "ยางลบ", url: "/images/clues/clue_eraser.png" },
  { id: "clue93", name: "พัดลม", url: "/images/clues/clue_fan.png" },
  { id: "clue94", name: "ม้วนฟิล์ม", url: "/images/clues/clue_film.png" },
  {
    id: "clue95",
    name: "ถังดับเพลิง",
    url: "/images/clues/clue_fire_extinguisher.png",
  },
  { id: "clue96", name: "ปลา", url: "/images/clues/clue_fish.png" },
  { id: "clue97", name: "เฟรนช์ฟราย", url: "/images/clues/clue_frenchfries.png" },
  { id: "clue98", name: "กบ", url: "/images/clues/clue_frog.png" },
  { id: "clue99", name: "แกลลอน", url: "/images/clues/clue_gallon.png" },
  { id: "clue100", name: "หน้ากากกันแก๊ส", url: "/images/clues/clue_gas_mask.png" },
  { id: "clue101", name: "ลูกโลก", url: "/images/clues/clue_globe.png" },
  { id: "clue102", name: "หมูปิ้ง", url: "/images/clues/clue_grilled_pork.png" },
  { id: "clue103", name: "กันพลา", url: "/images/clues/clue_gunpla.png" },
  { id: "clue104", name: "แบตตาเลี่ยน", url: "/images/clues/clue_hair_clipper.png" },
  { id: "clue105", name: "ไม้แขวนเสื้อ", url: "/images/clues/clue_hanger.png" },
  { id: "clue106", name: "หมวกกันน็อก", url: "/images/clues/clue_helmet.png" },
  { id: "clue107", name: "เสื้อฮู้ด", url: "/images/clues/clue_hoodie.png" },
  { id: "clue108", name: "ตั๊กแตน", url: "/images/clues/clue_hopper.png" },
  { id: "clue109", name: "หม้อไฟ", url: "/images/clues/clue_hotpot.png" },
  { id: "clue110", name: "นาฬิกาทราย", url: "/images/clues/clue_hourglass.png" },
  { id: "clue111", name: "แยม", url: "/images/clues/clue_jam.png" },
  { id: "clue112", name: "คีย์บอร์ด", url: "/images/clues/clue_keyboard.png" },
  { id: "clue113", name: "แมว", url: "/images/clues/clue_kitty.png" },
  { id: "clue114", name: "แมลงเต่าทอง", url: "/images/clues/clue_ladybug.png" },
  { id: "clue115", name: "โคมไฟ", url: "/images/clues/clue_lamp.png" },
  { id: "clue116", name: "สายแลน", url: "/images/clues/clue_lan.png" },
  { id: "clue117", name: "ตัวต่อ", url: "/images/clues/clue_lego.png" },
  { id: "clue118", name: "แมวกวัก", url: "/images/clues/clue_lucky_cat.png" },
  { id: "clue119", name: "แผนที่", url: "/images/clues/clue_map.png" },
  { id: "clue120", name: "ลูกแก้ว", url: "/images/clues/clue_marble.png" },
  { id: "clue121", name: "ไมโครโฟน", url: "/images/clues/clue_microphone.png" },
  { id: "clue122", name: "กล่องนม", url: "/images/clues/clue_milk.png" },
  { id: "clue123", name: "กระจก", url: "/images/clues/clue_mirror.png" },
  { id: "clue124", name: "ไม้ถูพื้น", url: "/images/clues/clue_mob.png" },
  { id: "clue125", name: "โมบายล์", url: "/images/clues/clue_mobile.png" },
  { id: "clue126", name: "มัมมี่", url: "/images/clues/clue_mummy.png" },
  { id: "clue127", name: "สร้อยคอ", url: "/images/clues/clue_necklace.png" },
  { id: "clue128", name: "โทรศัพท์บ้าน", url: "/images/clues/clue_old_phone.png" },
  { id: "clue129", name: "หัวหอม", url: "/images/clues/clue_onion.png" },
  { id: "clue130", name: "กระทะ", url: "/images/clues/clue_pan.png" },
  { id: "clue131", name: "เคสคอมพิวเตอร์", url: "/images/clues/clue_pc.png" },
  { id: "clue132", name: "น้ำหอม", url: "/images/clues/clue_perfume.png" },
  {
    id: "clue133",
    name: "เครื่องเล่นแผ่นเสียง",
    url: "/images/clues/clue_phonograph.png",
  },
  { id: "clue134", name: "พิซซ่า", url: "/images/clues/clue_pizza.png" },
  { id: "clue135", name: "เครื่องบิน", url: "/images/clues/clue_plane.png" },
  { id: "clue136", name: "ภาพถ่าย", url: "/images/clues/clue_portrait.png" },
  { id: "clue137", name: "ดอกกุหลาบ", url: "/images/clues/clue_rose.png" },
  { id: "clue138", name: "รองเท้าแตะ", url: "/images/clues/clue_sandals.png" },
  { id: "clue139", name: "จานดาวเทียม", url: "/images/clues/clue_satellite.png" },
  { id: "clue140", name: "เมมโมรี่การ์ด", url: "/images/clues/clue_SD.png" },
  { id: "clue141", name: "สาหร่าย", url: "/images/clues/clue_seaweed.png" },
  { id: "clue142", name: "น้ำแข็งไส", url: "/images/clues/clue_shaved_ice.png" },
  { id: "clue143", name: "สเกตบอร์ด", url: "/images/clues/clue_skateboard.png" },
  { id: "clue144", name: "โซล่าร์เซลล์", url: "/images/clues/clue_solarcell.png" },
  { id: "clue145", name: "ลำโพงบลูทูธ", url: "/images/clues/clue_speaker.png" },
  { id: "clue146", name: "สเต๊ก", url: "/images/clues/clue_steak.png" },
  { id: "clue147", name: "ตะเกียบ", url: "/images/clues/clue_stick.png" },
  { id: "clue148", name: "เข็มฉีดยา", url: "/images/clues/clue_syringe.png" },
  { id: "clue149", name: "เต๊นท์", url: "/images/clues/clue_tent.png" },
  { id: "clue150", name: "ตั๋ว", url: "/images/clues/clue_ticket.png" },
  { id: "clue151", name: "กล่องเครื่องมือ", url: "/images/clues/clue_tool_box.png" },
  { id: "clue152", name: "ยาสีฟัน", url: "/images/clues/clue_toothpaste.png" },
  { id: "clue153", name: "ที-เรกซ์", url: "/images/clues/clue_t-rex.png" },
  { id: "clue154", name: "กระเป๋าตังค์", url: "/images/clues/clue_wallet.png" },
  { id: "clue155", name: "บัวรดน้ำ", url: "/images/clues/clue_watering.png" },
];

export const AVATARS = [
  "/images/avatars/avatar01.svg",
  "/images/avatars/avatar02.svg",
  "/images/avatars/avatar03.svg",
  "/images/avatars/avatar04.svg",
  "/images/avatars/avatar05.svg",
  "/images/avatars/avatar06.svg",
  "/images/avatars/avatar07.svg",
  "/images/avatars/avatar08.svg",
  "/images/avatars/avatar09.svg",
  "/images/avatars/avatar10.svg",
  "/images/avatars/avatar11.svg",
  "/images/avatars/avatar12.svg",
  "/images/avatars/avatar13.svg",
  "/images/avatars/avatar14.svg",
  "/images/avatars/avatar15.svg",
  "/images/avatars/avatar16.svg",
  "/images/avatars/avatar17.svg",
  "/images/avatars/avatar18.svg",
  "/images/avatars/avatar19.svg",
  "/images/avatars/avatar20.svg",
  "/images/avatars/avatar21.svg",
  "/images/avatars/avatar22.svg",
  "/images/avatars/avatar23.svg",
  "/images/avatars/avatar24.svg",
  "/images/avatars/avatar25.svg",
  "/images/avatars/avatar26.svg",
  "/images/avatars/avatar27.svg",
  "/images/avatars/avatar28.svg",
  "/images/avatars/avatar29.svg",
  "/images/avatars/avatar30.svg",
  "/images/avatars/avatar31.svg",
  "/images/avatars/avatar32.svg",
  "/images/avatars/avatar33.svg",
  "/images/avatars/avatar34.svg",
  "/images/avatars/avatar35.svg",
  "/images/avatars/avatar36.svg",
  "/images/avatars/avatar37.svg",
  "/images/avatars/avatar38.svg",
  "/images/avatars/avatar39.svg",
  "/images/avatars/avatar40.svg",
];

export const ROLE_CARD_DESIGNS = {
  Murderer: ["/images/role_cards/card_murderer_v1.png", "/images/role_cards/card_murderer_v2.png"],
  Assistant: [
    "/images/role_cards/card_assistant_v1.png",
    "/images/role_cards/card_assistant_v2.png",
    "/images/role_cards/card_assistant_v3.png",
  ],
  Detective: ["/images/role_cards/card_detective_v1.png"],
  Agent: ["/images/role_cards/card_agent_v1.png"],
  Coroner: ["/images/role_cards/card_coroner_v1.png"],
  Innocent: [
    "/images/role_cards/card_innocent_v1.png",
    "/images/role_cards/card_innocent_v2.png",
    "/images/role_cards/card_innocent_v3.png",
    "/images/role_cards/card_innocent_v4.png",
    "/images/role_cards/card_innocent_v5.png",
  ],
};
